<template>
  <div class="common-chart">
    <div class="flex items-center justify-center">
      <div class="mr-4">
        <pie-chart :chartData="chartData" :chartId="chartId"></pie-chart>
      </div>
      <div>
        <div v-for="(item, index) in chartData" :key="index">
          <chart-detail-text
            :text="item.label"
            :color="item.color"
          ></chart-detail-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import ChartDetailText from "./ChartDetailText";
import PieChart from "./PieChart";

/*
 * 円グラフとテキストの共通パーツ
 */
export default {
  name: "M.ClaimTypesChart",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    chartId: {
      type: String,
      required: true,
    }
  },
  mixins: [ColorMixin],
  components: {
    ChartDetailText,
    PieChart
  },
}
</script>

<style>
</style>